// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeywordCloudNoZoom_keyword-cloud-container__DpnrX {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.KeywordCloudNoZoom_keyword-cloud-container__DpnrX .KeywordCloudNoZoom_operations-tab-outer__yw78c {
  width: 90%;
  display: flex;
  flex-direction: column;
}
.KeywordCloudNoZoom_keyword-cloud-container__DpnrX .KeywordCloudNoZoom_operations-tab-outer__yw78c .KeywordCloudNoZoom_operations-tab__PoPp9 {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 10px;
}
.KeywordCloudNoZoom_keyword-cloud-container__DpnrX .KeywordCloudNoZoom_operations-tab-outer__yw78c .KeywordCloudNoZoom_operations-tab__PoPp9 > * {
  align-self: flex-start;
  margin-right: 10px;
  /* Adjust the value to your desired spacing */
}
.KeywordCloudNoZoom_keyword-cloud-container__DpnrX .KeywordCloudNoZoom_operations-tab-outer__yw78c .KeywordCloudNoZoom_operations-tab__PoPp9 > *:last-child {
  margin-right: 0;
  /* Remove right margin from the last item */
}
.KeywordCloudNoZoom_keyword-cloud-container__DpnrX .KeywordCloudNoZoom_operations-tab-outer__yw78c .KeywordCloudNoZoom_time-picker__LIqTq {
  width: 100%;
  margin-left: 10px;
}

.KeywordCloudNoZoom_rightclick-context-menu-keyword-cloud__qn-1g {
  position: absolute;
  width: 150px;
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid lightgray;
  background-color: white;
  color: black;
}

.KeywordCloudNoZoom_rightclick-context-menu-keyword-cloud__qn-1g ul {
  padding: 2px;
  margin: 0;
  list-style: none;
}

.KeywordCloudNoZoom_rightclick-context-menu-keyword-cloud__qn-1g li {
  padding: 4px;
  font-size: 14px;
}

.KeywordCloudNoZoom_rightclick-context-menu-keyword-cloud__qn-1g li:hover {
  background-color: gray;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/KeywordCloudNoZoom/KeywordCloudNoZoom.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AACF;AACE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;AACN;AAEI;EACE,sBAAA;EACA,kBAAA;EACA,6CAAA;AAAN;AAGI;EACE,eAAA;EACA,2CAAA;AADN;AAII;EACE,WAAA;EACA,iBAAA;AAFN;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,SAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YAAA;EACA,eAAA;AAJF;;AAOA;EACE,sBAAA;EACA,YAAA;AAJF","sourcesContent":[".keyword-cloud-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n  .operations-tab-outer {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n\n    .operations-tab {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      margin: 10px;\n      border: 1px solid lightgray;\n      border-radius: 10px;\n      padding: 10px;\n    }\n\n    .operations-tab > * {\n      align-self: flex-start;\n      margin-right: 10px;\n      /* Adjust the value to your desired spacing */\n    }\n\n    .operations-tab > *:last-child {\n      margin-right: 0;\n      /* Remove right margin from the last item */\n    }\n\n    .time-picker {\n      width: 100%;\n      margin-left: 10px;\n    }\n  }\n}\n\n.rightclick-context-menu-keyword-cloud {\n  position: absolute;\n  width: 150px;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: 1px solid lightgray;\n  background-color: white;\n  color: black;\n}\n\n.rightclick-context-menu-keyword-cloud ul {\n  padding: 2px;\n  margin: 0;\n  list-style: none;\n}\n\n.rightclick-context-menu-keyword-cloud li {\n  padding: 4px;\n  font-size: 14px;\n}\n\n.rightclick-context-menu-keyword-cloud li:hover {\n  background-color: gray;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyword-cloud-container": `KeywordCloudNoZoom_keyword-cloud-container__DpnrX`,
	"operations-tab-outer": `KeywordCloudNoZoom_operations-tab-outer__yw78c`,
	"operations-tab": `KeywordCloudNoZoom_operations-tab__PoPp9`,
	"time-picker": `KeywordCloudNoZoom_time-picker__LIqTq`,
	"rightclick-context-menu-keyword-cloud": `KeywordCloudNoZoom_rightclick-context-menu-keyword-cloud__qn-1g`
};
export default ___CSS_LOADER_EXPORT___;
